module.exports = __webpack_public_path__ + "static/media/logo-light.c93a7a48.png";